<template>
    <div class="main-container">
       <el-tabs v-model="activeName">
            <el-tab-pane label="个人信息" name="user">
                <UserInfoComponent v-if="activeName == 'user'"/>
            </el-tab-pane>
            <el-tab-pane label="修改密码" name="pwd">
                <ModifyPwdComponent v-if="activeName == 'pwd'"/>
            </el-tab-pane>
            <el-tab-pane label="银行卡信息" name="bank">
                <BankCardComponent v-if="activeName == 'bank'"/>
            </el-tab-pane>
            <el-tab-pane label="我的钱包" name="wallet">
                <MyWalletComponent v-if="activeName == 'wallet'"/>
            </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import UserInfoComponent from "./components/userInfoComponent";
import ModifyPwdComponent from "./components/modifyPwdComponent";
import BankCardComponent from "./components/bankCardComponent";
import MyWalletComponent from "./components/myWalletComponent";
export default {
    components: {
        UserInfoComponent,
        ModifyPwdComponent,
        BankCardComponent,
        MyWalletComponent
    },
    name: "userInfo",
    data() {
        return {
            activeName: "user"
        }
    },
    methods: {
        

    },
    mounted() {

    },

}
</script>

<style type="less" scoped>
    @import url("./index.less");
</style>
